<div class="detalle-categoria-container">
  <div *ngIf="isLoading" class="loading-indicator">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="50"
    ></mat-progress-spinner>
    <p>Cargando configuración...</p>
  </div>

  <form
    [formGroup]="configForm"
    (ngSubmit)="onSubmit()"
    *ngIf="!isLoading && (parametrosAgrupados$ | async) as grupos"
  >
    <div *ngIf="!grupos || grupos.length === 0" class="no-parametros">
      <mat-icon>settings_ethernet</mat-icon>
      <p>
        No hay parámetros de configuración para mostrar en esta categoría o la
        categoría no existe.
      </p>
      <button mat-stroked-button routerLink="/configuracion">
        Volver a Parametrización
      </button>
    </div>

    <ng-container *ngIf="grupos && grupos.length > 0">
      <div
        *ngFor="let grupo of grupos; trackBy: trackByGrupoNombre"
        class="grupo-parametros mat-elevation-z2"
      >
        <h2 class="grupo-titulo">
          <mat-icon *ngIf="grupo.iconoGrupo">{{ grupo.iconoGrupo }}</mat-icon>
          {{ grupo.grupoNombre || "Parámetros Adicionales" }}
        </h2>
        <mat-divider></mat-divider>

        <div
          *ngFor="let param of grupo.parametros; trackBy: trackByParamId"
          class="parametro-item"
          [class.parametro-item-html]="param.tipoParametro.tipoDato === 'html'"
        >
          <!-- Layout normal para todos los tipos excepto HTML -->
          <ng-container *ngIf="param.tipoParametro.tipoDato !== 'html'">
            <div class="parametro-info">
              <div class="etiqueta-container">
                <mat-icon
                  *ngIf="param.tipoParametro.iconoEtiqueta"
                  class="etiqueta-icono"
                  >{{ param.tipoParametro.iconoEtiqueta }}</mat-icon
                >
                <label [for]="param.tipoParametro.nombre"
                  >{{ param.tipoParametro.etiqueta }}
                  <span
                    *ngIf="param.tipoParametro.esRequerido"
                    class="required-asterisk"
                    >*</span
                  >
                </label>
                <mat-icon
                  *ngIf="param.tipoParametro.requiereReinicio"
                  matTooltip="Cambiar este valor requiere reiniciar la aplicación"
                  class="icono-reinicio"
                  >restart_alt</mat-icon
                >
              </div>
              <small
                *ngIf="param.tipoParametro.descripcion"
                class="parametro-descripcion"
                >{{ param.tipoParametro.descripcion }}</small
              >
            </div>

            <div class="parametro-control">
              <ng-container [ngSwitch]="param.tipoParametro.tipoDato">
                <mat-form-field appearance="outline" *ngSwitchCase="'string'">
                  <mat-label>{{ param.tipoParametro.etiqueta }}</mat-label>
                  <input
                    matInput
                    [formControlName]="param.tipoParametro.nombre"
                    [id]="param.tipoParametro.nombre"
                    [readonly]="param.tipoParametro.soloLectura"
                  />
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('required')
                    "
                  >
                    Este campo es requerido
                  </mat-error>
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('pattern')
                    "
                  >
                    El formato ingresado no es válido
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngSwitchCase="'textarea'">
                  <mat-label>{{ param.tipoParametro.etiqueta }}</mat-label>
                  <textarea
                    matInput
                    [formControlName]="param.tipoParametro.nombre"
                    [id]="param.tipoParametro.nombre"
                    [readonly]="param.tipoParametro.soloLectura"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5"
                  ></textarea>
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('required')
                    "
                  >
                    Este campo es requerido
                  </mat-error>
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('pattern')
                    "
                  >
                    El formato ingresado no es válido
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngSwitchCase="'int'">
                  <mat-label>{{ param.tipoParametro.etiqueta }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [formControlName]="param.tipoParametro.nombre"
                    [id]="param.tipoParametro.nombre"
                    [readonly]="param.tipoParametro.soloLectura"
                  />
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('required')
                    "
                  >
                    Este campo es requerido
                  </mat-error>
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('pattern')
                    "
                  >
                    El formato numérico no es válido
                  </mat-error>
                </mat-form-field>

                <div *ngSwitchCase="'bool'" class="bool-control">
                  <mat-slide-toggle
                    [formControlName]="param.tipoParametro.nombre"
                    [id]="param.tipoParametro.nombre"
                    [disabled]="
                      param.tipoParametro.soloLectura ||
                      !param.tipoParametro.esEditable
                    "
                  >
                    {{ param.tipoParametro.etiqueta }}
                  </mat-slide-toggle>
                </div>

                <mat-form-field appearance="outline" *ngSwitchCase="'enum'">
                  <mat-label>{{ param.tipoParametro.etiqueta }}</mat-label>
                  <mat-select
                    [formControlName]="param.tipoParametro.nombre"
                    [id]="param.tipoParametro.nombre"
                    [disabled]="
                      param.tipoParametro.soloLectura ||
                      !param.tipoParametro.esEditable
                    "
                  >
                    <mat-option
                      *ngFor="
                        let opcion of getOpcionesEnum(param);
                        trackBy: trackByOpcionValor
                      "
                      [value]="opcion.valor"
                    >
                      {{ opcion.texto }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="getOpcionesEnum(param).length === 0">
                    No hay opciones disponibles
                  </mat-hint>
                  <mat-error
                    *ngIf="
                      configForm
                        .get(param.tipoParametro.nombre)
                        ?.hasError('required')
                    "
                  >
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>

                <!-- Puedes añadir casos para 'date', etc. -->
                <div *ngSwitchDefault class="parametro-default">
                  Tipo de dato no soportado para edición:
                  {{ param.tipoParametro.tipoDato }}
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Layout especial para campos HTML en columna -->
          <ng-container *ngIf="param.tipoParametro.tipoDato === 'html'">
            <div class="parametro-info-full">
              <div class="etiqueta-container">
                <mat-icon
                  *ngIf="param.tipoParametro.iconoEtiqueta"
                  class="etiqueta-icono"
                  >{{ param.tipoParametro.iconoEtiqueta }}</mat-icon
                >
                <label [for]="param.tipoParametro.nombre"
                  >{{ param.tipoParametro.etiqueta }}
                  <span
                    *ngIf="param.tipoParametro.esRequerido"
                    class="required-asterisk"
                    >*</span
                  >
                </label>
                <mat-icon
                  *ngIf="param.tipoParametro.requiereReinicio"
                  matTooltip="Cambiar este valor requiere reiniciar la aplicación"
                  class="icono-reinicio"
                  >restart_alt</mat-icon
                >
              </div>
              <small
                *ngIf="param.tipoParametro.descripcion"
                class="parametro-descripcion"
                >{{ param.tipoParametro.descripcion }}</small
              >
            </div>

            <div class="html-editor-container">
              <div class="editor-wrapper">
                <ngx-editor-menu
                  [editor]="getEditor(param.tipoParametro.nombre)"
                ></ngx-editor-menu>
                <ngx-editor
                  [editor]="getEditor(param.tipoParametro.nombre)"
                  [formControlName]="param.tipoParametro.nombre"
                  [disabled]="
                    param.tipoParametro.soloLectura ||
                    !param.tipoParametro.esEditable
                  "
                  [placeholder]="'Ingrese contenido HTML...'"
                >
                </ngx-editor>
              </div>
              <div
                *ngIf="
                  configForm
                    .get(param.tipoParametro.nombre)
                    ?.hasError('required')
                "
                class="mat-error"
              >
                Este campo es requerido
              </div>
              <div
                *ngIf="
                  configForm
                    .get(param.tipoParametro.nombre)
                    ?.hasError('pattern')
                "
                class="mat-error"
              >
                El formato HTML no es válido
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <mat-divider class="action-divider"></mat-divider>
      <div class="action-buttons" *ngIf="grupos && grupos.length > 0">
        <button
          mat-stroked-button
          type="button"
          (click)="cancelChanges()"
          [disabled]="configForm.pristine || isSaving"
        >
          <mat-icon>cancel</mat-icon> Descartar Cambios
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="!canSave || isSaving"
        >
          <mat-icon *ngIf="!isSaving">save</mat-icon>

          {{ isSaving ? "Guardando..." : "Guardar Cambios" }}
        </button>
      </div>
    </ng-container>
  </form>
</div>
